<template>
    <div class="app-container">
        <el-table v-loading="loading" :data="shuidianGuizeList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="水费" align="center" prop="shuiDun">
                <template slot-scope="scope">
                    <label>{{ scope.row.shuiDun / 100 }} 元/吨</label>
                </template>
            </el-table-column>
            <el-table-column label="电费" align="center" prop="dianDu">
                <template slot-scope="scope">
                    <label>{{ scope.row.dianDu / 100 }} 元/度</label>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"
                        v-hasPermi="['fang:shuidianGuize:edit']"
                    >修改
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 添加或修改水电费扣费规则对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="水费" prop="shuiDun">
                    <el-input v-model="form.shuiDun" style="width: 300px" placeholder="请输入水费"/>
                    <span>/吨</span>
                </el-form-item>
                <el-form-item label="电费" prop="dianDu">
                    <el-input v-model="form.dianDu" style="width: 300px" placeholder="请输入电费"/>
                    <span>/度</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listShuidianGuize,
    getShuidianGuize,
    delShuidianGuize,
    addShuidianGuize,
    updateShuidianGuize
} from "@/api/homestay/api";

export default {
    name: "ShuidianGuize",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 水电费扣费规则表格数据
            shuidianGuizeList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                shuiDun: null,
                dianDu: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                shuiDun: [
                    {required: true, message: "水费不能为空", trigger: "blur"}
                ],
                dianDu: [
                    {required: true, message: "电费(元)/度不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询水电费扣费规则列表 */
        getList() {
            this.loading = true;
            listShuidianGuize(this.queryParams).then(response => {
                this.shuidianGuizeList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                shuiDun: null,
                dianDu: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加水电费扣费规则";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const ids = row.id || this.ids.ids.join(',')
            getShuidianGuize({'id': ids}).then(response => {
                this.form = response.data;
                this.form.shuiDun = response.data.shuiDun / 100;
                this.form.dianDu = response.data.dianDu / 100;
                this.open = true;
                this.title = "扣费规则";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateShuidianGuize(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addShuidianGuize(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids;
            this.$modal.confirm('是否确认删除水电费扣费规则编号为"' + ids + '"的数据项？').then(function () {
                return delShuidianGuize(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
    }
};
</script>
